import React from 'react'
import classes from './Global.module.css'

function PlayAllButton(type) {
    if(type === 'primary') {
        return (
            <button className={`btn ${classes.play_btn} ${classes.primary}`}><i className="fa-solid fa-circle-play"></i> Play all</button>
        )
    }else {
        return (
            <button className={`btn ${classes.play_btn} ${classes.secondary}`}><i className="fa-solid fa-play"></i> Play all</button>
        )
    }
}

export default PlayAllButton